import * as React from "react";
import { BaseBlock, broadcastBlockLoad, internalMessageBus } from "../../ExternalDependencies";
import { dict } from "./dict";
import { config } from "./config";
import { RealityCheck } from "./ui";
import { RealityCheckState } from "./state";
import { mergeConfig } from "./helpers";
import { Parser } from "../../Parser";
import { Retriever } from "../../Retriever";
export class RealityCheckRoot extends BaseBlock {
    constructor(domId, options) {
        super(domId, options);
        this.dataProvider = new RealityCheckState({
            cms: mergeConfig(config, options.cms),
            dict: Object.assign(Object.assign({}, dict), (options.dict || {})),
            provider: new Parser(new Retriever(options.dataProvider, internalMessageBus)),
            internalMessageBus,
            logoutHandler: options.logoutHandler,
            localizationLib: options.localizationLib
        });
        this.props = { dataProvider: this.dataProvider };
    }
    activate() {
        return super.activate(React.createElement(RealityCheck, Object.assign({}, this.props)));
    }
}
window["RealityCheck"] = RealityCheckRoot;
broadcastBlockLoad("RealityCheck");
//# sourceMappingURL=index.js.map